// New Authorize.Net reconciliation page — renders the shared ReconWorkspace with the AuthNet config.
// Parallel to the existing AuthnetReconciliationPage (untouched); surfaced as "… (New)" in the menu
// during transition. See docs/recon-workspace-design.md.
import React from 'react';
import ReconWorkspace from '../../components/recon/ReconWorkspace';
import authnetConfig from '../../config/recon/authnet';

export default function AuthnetReconciliationNewPage() {
  return <ReconWorkspace config={authnetConfig} />;
}
